/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AttachmentIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5klEQVR4nM2U30sVURDHtwiKQugHGqX9C0H+A/t0YeHu/DjROqPeuL0nQQ8RPt0/RyWwpxKi1xDRIrgi+OBr/njyQRAtLWZ/XFfbu7jXKzhw2OWcOZ85c+Y7x/OuuF3rOxBRXyDJApDuIuvf+Ev6GVieXyhgFEX3kfWrQbsOki/mVxkOoA+BdC2B6CY6fe3c5CNbq9ejYXT6Bki20/V2vT5xr1d4G1EfF/kRyRNkWU0zWegJHkTRYJl/nA3LlvkTjUPP8FqtcScMw9uF+1imkprIx8rwIIoGgWUeSP/Eg+XD2aLaFSbqku1KcMjPs/4GkqP0vufy+1ut1nVkPbYD9AYnbZuCAPSpgSyY32zeOl2HggzOCw/SeecmRywLIDnMBzDJxgFY5jtwKxiw/CgqKJL+LAsKrLP502f9ACxhrvI6nbb9+lkpIukisCx3y4j55YMko8ZQ3CcJ/NOp68kWQh73CyufWvfrOoEXdjKS7APpgSnAuyDcucbQf5uRdCdWBOJA3+Fm1jBp973zqsA5e3tK4GahGxs1uaXjPVHzru/7N8BpDUk2SuEsq6XwzklJXlmA7G23Tjz5l6W8iirDM0PUZ0A6AyS/kGUPWFYQ9W0QBDc7PqTfM7gF8/ptwPrNAl8K/EraP3Hbh3l7CWS+AAAAAElFTkSuQmCC)
 */
export const AttachmentIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.57 4.01a6.97 6.97 0 0 1 9.86 0l.54.55a6.99 6.99 0 0 1 0 9.88l-7.26 7.27a1 1 0 0 1-1.42-1.42l7.27-7.26a4.99 4.99 0 0 0 0-7.06L19 5.43a4.97 4.97 0 0 0-7.02 0l-8.02 8.02a3.24 3.24 0 1 0 4.58 4.58l6.24-6.24a1.12 1.12 0 0 0-1.58-1.58l-3.5 3.5a1 1 0 0 1-1.42-1.42l3.5-3.5a3.12 3.12 0 1 1 4.42 4.42l-6.24 6.24a5.24 5.24 0 0 1-7.42-7.42l8.02-8.02Z"
        className={colorClass}
      />
    </svg>
  );
};
